import React from "react";
import RiskStatusCard from "../RiskStatusCard";



const OverviewTab = () => {

  return (
    <div
      className="p-6 rounded-lg text-white w-full"
      style={{
        background:
          "linear-gradient(90deg, rgba(137, 168, 176, 0.1512) 0%, rgba(255, 255, 255, 0) 100%)",
        border: "1px solid #ffffff38",
      }}
    >
      <h2 className="text-center text-xl md:text-2xl font-semibold mb-8">
        PROFITPULSE EA XAUUSD
      </h2>
      <div className="flex flex-wrap justify-center gap-2">
        {(
          <>
            <RiskStatusCard
              
            />
            <RiskStatusCard
              
            />
            <RiskStatusCard
             
            />
            <RiskStatusCard
              
            />
            <RiskStatusCard
              
            />
              
          </>
        )}
      </div>
    </div>
  );
};

export default OverviewTab;
